import React from 'react'

type HomeContentGridProps = {
  faq: React.ReactNode
  support: React.ReactNode
  outstandingItemsCard?: React.ReactNode
  healthRecordsManagementCard?: React.ReactNode
}

const HomeContentGrid: React.FC<HomeContentGridProps> = ({
  faq,
  support,
  outstandingItemsCard,
  healthRecordsManagementCard,
}) => {
  if (outstandingItemsCard || healthRecordsManagementCard) {
    return (
      <section className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(320px,420px)]">
        <div className="space-y-6">
          {outstandingItemsCard}
          {healthRecordsManagementCard}
        </div>
        <div className="space-y-6">
          {faq}
          {support}
        </div>
      </section>
    )
  }

  return (
    <section className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(320px,420px)]">
      {faq}
      {support}
    </section>
  )
}

export default HomeContentGrid
